// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Customer-surface scope for the file-extents system (design direction,
// 2026-09-11): extents are IMAGERY on the 2D viewer only, toggled from the
// Orthomosaic pane ("Show Imagery Tile Extents"); the customer Project
// Details map stays quiet (rows still select, purely to feed the bulk
// Download pills), and the floating on-map switch card is retired on
// customer surfaces. ADMIN ignores these flags and keeps the full system.
//
// The complete customer experience - las/pano boxes, the floating switch
// card with its per-kind filter list, Project Details map sync (boxes,
// captions, raster fade, double-click zoom, the numbered row ovals) - is
// intentionally PRESERVED in the codebase and last shipped as commit
// 8fda9ca2a (the dev state, 2026-09-11). Full restore = all three flags
// true; nothing else needs to change.

// Project Details map reactions + its numbered row ovals: boxes, captions,
// fade, double-click zoom.
export const PROJECT_DETAILS_EXTENTS_ENABLED = false;

// The on-map extents card for customers: the master switch plus, with 2+
// kinds present, the per-kind filter list and line-style swatches. Admin
// always shows it.
export const EXTENTS_LEGEND_ENABLED = false;

// Non-imagery kinds (point clouds, panoramas) on the 2D viewer map. While
// this is on, MapFileFootprints also shows the card above, so multi-kind
// boxes never ship without their legend and filtering.
export const VIEWER_2D_ALL_KINDS_ENABLED = false;

// Surface gates: every admin/surface decision the extents system makes lives
// here, so the flags above plus these three functions are the whole story.
// Functions (not constants) because they read _ADMIN_ per call.

// Whether the footprints system exists on this surface at all. Also gates the
// raster fade (MapRasterLayer) - the fade is an extents reaction and must die
// with the system.
export const extentsSurfaceEnabled = (showLayers: boolean): boolean =>
  _ADMIN_ || showLayers || PROJECT_DETAILS_EXTENTS_ENABLED;

// The floating switch card. All-kinds implies the card: multi-kind boxes
// never render without a way to tell them apart and filter them.
export const extentsCardEnabled = (): boolean =>
  _ADMIN_ || EXTENTS_LEGEND_ENABLED || VIEWER_2D_ALL_KINDS_ENABLED;

// Non-imagery kinds on this surface (the MapFileFootprints includeLas prop).
export const extentsAllKindsEnabled = (showLayers: boolean): boolean =>
  !showLayers || _ADMIN_ || VIEWER_2D_ALL_KINDS_ENABLED;
